module.exports = __webpack_public_path__ + "img/cbam-bg.c780c2eb.png";